/**
 * Created by christiancueni on 28/06/18.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { CustomAction } from '../actions/CustomAction';
import { type } from '../shared/util';
import { PushRegistration } from './app.models';

export const AppActionTypes = {
  APP_SET_ONLINE: type("[App] Set online"),
  APP_SET_OFFLINE: type("[App] Set offline"),
  APP_HAS_PUSH: type("[App] Has push"),
  APP_NO_PUSH: type("[App] No push"),
  APP_SET_PUSH_ID: type("[App] Set push ID"),
};

export class AppSetOnline implements CustomAction {
  type = AppActionTypes.APP_SET_ONLINE;

  constructor() { }
}

export class AppSetOffline implements CustomAction {
  type = AppActionTypes.APP_SET_OFFLINE;

  constructor() { }
}

export class AppHasPushAction implements CustomAction {
    type = AppActionTypes.APP_HAS_PUSH;

    constructor() { }
  }

export class AppNoPushAction implements CustomAction {
type = AppActionTypes.APP_NO_PUSH;

constructor() { }
}

export class AppSetPushId implements CustomAction {
    type = AppActionTypes.APP_SET_PUSH_ID;

    constructor(public payload: PushRegistration) {}
}


export type AppActions =
    AppSetOnline |
    AppSetOffline |
    AppHasPushAction |
    AppNoPushAction |
    AppSetPushId;

